import template from './skill-prompt.md?raw'

/**
 * Builds the PhoneSalad skill prompt to paste into an AI agent (OpenClaw, etc.)
 * Template is in skill-prompt.md — edit that file to change the prompt content.
 */
export function buildPhoneSaladPrompt(apiKey: string): string {
  return template.replace(/\{\{API_KEY\}\}/g, apiKey)
}
